import { Cell } from '../../../../components/ReusableComponents/Table'
import styles from './HotelNameCell.module.scss'

const HotelNameCell = ({ brand, name, groupName, navigationControl, ...props }) => (
  <Cell
    className={
      navigationControl ? styles.hotelNameCellWithNavigation : styles.hotelNameCell
    }
    {...props}
    noHoverStyle
  >
    <div className={styles.wrapper}>
      <div className={styles.hotelBrand}>{brand}</div>
      <div className={styles.hotelShortName} data-tip={name}>
        {name}
      </div>
      {navigationControl && (
        <div className={styles.navigationControl}>{navigationControl}</div>
      )}
      {groupName && <div className={styles.tooltip}>{groupName}</div>}
    </div>
  </Cell>
)

export default HotelNameCell
